module.exports = __webpack_public_path__ + "static/media/Протокол от СД за свикване на ОСА.3a4b90de.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Протокол от СД за свикване на ОСА.pdf
// module id = 115
// module chunks = 0